export enum UserRole {
    Operator = 'operator',
    Administrator = 'administrator'
}
